<template>
    <keep-alive>
        <component :is="loadPages"></component>
    </keep-alive>

    <Footer id="footer_section" class="fixed-bottom" />
</template>


<script>
    import { computed, defineAsyncComponent, onBeforeMount } from "vue";

    import { useStore } from "@/system_modules/store";
    import { useRoute } from "vue-router";

    import Footer from '@/components/footer/Footer2.vue';

    import { G, ajax } from "@/_common";

    export default {
        name: '404errorL',
        components: {
            Footer,
        },
        props: {
            data: {
                type: Object,
                default: () => {}
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();

            const def_lang = route.params && route.params.lang !== undefined ? route.params.lang.substring(0,2) : "az";
            store.setLang(def_lang);

            const gpage = G.current;

            gpage.page = props.data
                ? props.data.page || G.defaultPage
                : G.defaultPage;

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        store.setTranslations(e.data);
                    },
                });

                await ajax({
                    url: store.getSystemSettings('system'),
                    success: async (x) => {
                        let res = x.data || null;
                        if ( x.status == 200 && res ) {
                            if( res.company !== undefined ){
                                for(let a in res){
                                    G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                                }
                                document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                            }
                            else{
                                G.systemData = res;
                            }
                        }
                    },
                });
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`),
                    errorComponent: defineAsyncComponent(() =>
                        import("@/pages/NotFound")
                    ),
                });
            });

            return { loadPages };
        },
    };
</script>


<style lang="scss">
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }
</style>
